import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:27</span> Guest Introduction</li>
                            <li><span>01:58</span> How two engineers became patent experts.</li>
                            <li><span>03:11</span> How Dan helped NASA Scientists acquire their patents</li>
                            <li><span>05:38</span> Are NDAs important for businesses applying for an IP.</li>
                            <li><span>08:40</span> The process of applying for a Patent.</li>
                            <li><span>10:45</span> How to Know if your idea is patentable according to the US Patent Law.</li>
                            <ul className="sub__list">
                                <li> - 101 Patent – Patent Subject Matter</li>
                                <li> - 102 Patent – Novelty</li>
                                <li> - 103 Patent – Non-obviousness</li>
                                <li> - 112 Patent – Written Descriptions</li>
                            </ul>
                            <li>
                                <span>13:58</span> How are patents law enforced, and are patents universal?</li>
                            <ul className="sub__list">
                                <li> - Process of enforcing a patent law</li>
                                <li> - How businesses can use provisional patents to pursue VCs and investors</li>
                            </ul>
                            <li><span>22:17</span> Do patents in essential services hinder technological developments that can help people?</li>
                            <ul className="sub__list">
                                <li> - Compulsory Licensing outside of the US</li>
                                <li> - Improvement in Research and Development</li>
                                <li> - Public Disclosure promotes development globally and stops information hoarding and obfuscation.</li>
                                <li> - Information accessibility allows other people to improve on those innovations more rapidly.</li>
                            </ul>
                            <li><span>31:00</span> How do patents improve the value of a business looking for mergers and acquisitions</li>
                            <ul className="sub__list">
                                <li> - Buying and Selling Patents</li>
                                <li> - Patent Bundling and Licensing</li>
                                <li> - How do Patents change a business’s valuation in the market?
                                </li>
                            </ul>
                            <li><span>35:22</span> Should businesses invest in Patents and R&amp;D during crises, such as Financial Crisis and COVID-19 pandemic?</li>
                            <ul className="sub__list">
                                <li> - Has the patent industry taken a significant fall as a result of the current
                                    pandemic?</li>
                                <li> - The impact of businesses becoming more digitally oriented.</li>
                            </ul>
                            <li><span>37:16</span> How did Dan start the American Patent Agency and their road to success as a business.
                            </li>
                            <ul className="sub__list">
                                <li> - What it takes to be an entrepreneur</li>
                                <li> - Identifying the potential of a business</li>
                                <li> - Exploring technology such as AI and Machine Learning</li>
                            </ul>
                            <li><span>42:42</span> What is the future of APA and its goals?
                            </li>
                            <ul className="sub__list">
                                <li> - As Mentors and as the go-to patent experts for IP protection</li>
                            </ul>
                            <li><span>44:20</span> The story of Dan and Stephen’s First Patent.</li>
                            <li><span>47: 17</span> How can technology help improve the process of applying for a patent.</li>
                            <ul className="sub__list">
                                <li> - Legal Tech and its application</li>
                                <li> - Uses for Machine Learning and Artificial Intelligence</li>
                                <li> - Automating Legal Documentation and Patent Documentation</li>
                            </ul>
                            <li><span>50:51</span> Steps entrepreneurs should take before contacting a Paten agency like APA?</li>
                            <ul className="sub__list">
                                <li> - Documentation</li>
                                <li> - Long-term use case identification</li>

                            </ul>
                            <li><span>53:48 </span> A final word of advice for entrepreneurs looking to protect their IP.</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;